"use strict";

require("core-js/modules/es6.array.fill");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      text-decoration: none;\n      color: inherit;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        font-size: inherit;\n        font-weight: inherit;\n        font-family: inherit;\n        color: inherit;\n        background: none;\n        border: none;\n        outline: none;\n        margin: 0;\n        padding: 0;\n      "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    border-radius: ", "px;\n    padding: 0 ", "px;\n\n    ", "}\n    ", "}\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  box-sizing: border-box;\n  cursor: pointer;\n\n  width: 100%;\n  font-size: 14px;\n  letter-spacing: 0;\n\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n          height: 60px;\n          font-size: 20px;\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        max-width: ", "px;\n        font-weight: 700;\n\n        ", "\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          font-size: 16px;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        max-width: ", "px;\n        height: ", "px;\n\n        font-weight: 600;\n        align-items: center;\n        justify-content: center;\n\n        ", "\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        max-width: ", "px;\n        height: ", "px;\n        font-weight: 500;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        background: ", ";\n        border: ", " ", ";\n        box-shadow: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid #999999;\n        background-color: #cccccc;\n        color: #666666;\n        cursor: default;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        background: ", ";\n        box-shadow: ", ";\n        border: ", " ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n        background: ", ";\n        border: ", " ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        width: calc(100% - 2px);\n        height: calc(100% - 2px);\n        top: 1px;\n        left: 1px;\n\n        color: ", ";\n\n        background: ", " 100% 100%;\n        box-shadow: ", ";\n\n        & > span {\n          z-index: 2;\n          position: relative;\n        }\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          z-index: 1;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          opacity: 0;\n          border-radius: ", "px;\n          background: ", " 100% 100%;\n          transition: all ", "ms\n            ", ";\n        }\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          z-index: 1;\n          border-radius: ", "px;\n          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n        }\n\n        &:hover::before {\n          opacity: 1;\n        }\n\n        &:active {\n          background: ", ";\n        }\n\n        &:active::before {\n          opacity: 0;\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var Button_1 = require("./Button");

var designs = function designs(_ref) {
  var design = _ref.design,
      theme = _ref.theme;

  switch (design) {
    case Button_1.Designs.Primary:
      return styled_components_1.css(_templateObject(), bitcoincom_pkg_theme_1.colors.solid.white, bitcoincom_pkg_theme_1.colors.fill.gradient, theme.shadows.boxShadow.buttonPrimary, theme.border.radius["default"], bitcoincom_pkg_theme_1.colors.fill.gradientLight, theme.transitions.duration["default"], theme.transitions.easing.easeInOut, theme.border.radius["default"], bitcoincom_pkg_theme_1.colors.fill.gradientDark);

    case Button_1.Designs.Dark:
      return styled_components_1.css(_templateObject2(), theme.palette.text.contrast, theme.palette.background.contrast, theme.border.solid["default"], theme.palette.border.contrast);

    case Button_1.Designs.Danger:
      return styled_components_1.css(_templateObject3(), theme.palette.text.contrast, bitcoincom_pkg_theme_1.colors.gradient.cinnabar, theme.shadows.boxShadow.button, theme.border.solid["default"], bitcoincom_pkg_theme_1.colors.gradient.cinnabar);

    case Button_1.Designs.Disabled:
      return styled_components_1.css(_templateObject4());

    default:
      return styled_components_1.css(_templateObject5(), theme.palette.text["default"], theme.palette.background["default"], theme.border.solid["default"], theme.palette.border["default"], theme.shadows.boxShadow.button);
  }
};

var sizes = function sizes(_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;

  switch (size) {
    case Button_1.Sizes.Tiny:
      return styled_components_1.css(_templateObject6(), theme.spacing.unit * 13, theme.spacing.unit * 4);

    case Button_1.Sizes.Small:
      return styled_components_1.css(_templateObject7(), theme.spacing.unit * 19, theme.spacing.unit * 5, bitcoincom_pkg_theme_1.media.sm(_templateObject8()));

    case Button_1.Sizes.Default:
    default:
      return styled_components_1.css(_templateObject9(), theme.spacing.unit * 6, theme.spacing.unit * 37, bitcoincom_pkg_theme_1.media.sm(_templateObject10()));
  }
};

var common = styled_components_1.css(_templateObject11(), function (_ref3) {
  var size = _ref3.size,
      design = _ref3.design,
      theme = _ref3.theme;
  return styled_components_1.css(_templateObject12(), theme.border.radius["default"], theme.spacing.unit * 2, designs({
    design: design,
    theme: theme
  }), sizes({
    size: size,
    theme: theme
  }));
});
exports.StyledButton = styled_components_1["default"].button(_templateObject13(), function (_ref4) {
  var href = _ref4.href;
  if (href === undefined || href === "") return styled_components_1.css(_templateObject14());
  return styled_components_1.css(_templateObject15());
}, common);
exports["default"] = exports.StyledButton;